<template>
	<div
		class="flex flex-col items-start justify-between space-y-2 border-b border-gray-200 py-sm"
	>
		<div class="flex items-center space-x-3">
			<!-- NOTE: duplicated in product-shop-picker -->

			<div
				v-if="outlet.availableQuantity >= 5 && showBall"
				class="ml-1 size-3 rounded-full bg-green-500"
			></div>

			<div
				v-else-if="
					outlet.availableQuantity > 0 &&
					outlet.availableQuantity < 5 &&
					showBall
				"
				class="ml-1 size-3 rounded-full bg-yellow-500"
			></div>

			<p>
				{{ outlet.outlet.title }}
			</p>
		</div>
	</div>
</template>

<script setup lang="ts">
import type {OutletData} from "@pkg/shared/composables/use-outlet-stocks";

defineProps<{
	outlet: OutletData;
	isBuyable: boolean;
	showBall?: boolean;
}>();
</script>

<!-- eslint-disable max-len -->
<i18n lang="json">
{
	"et": {
		"availability-buy-now": "Kohe laos ja näidis olemas",
		"availability-few-left": "Veel viimased laos ja näidis olemas",
		"availability-buy-now-no-model": "Kohe kaupluse laost saadaval",
		"model-order-from-store": "Näidis olemas ja kauplusest tellitav ",
		"temporarily-out-of-stock": "Kauplusest tellitav",
		"not-available": "Toode pole saadaval",
		"ask-from-store": "Küsi kauplusest!"
	},
	"fi": {
		"availability-buy-now": "Heti varastossa ja malli esillä",
		"availability-few-left": "Mallikappale esillä",
		"availability-buy-now-no-model": "Heti myymälän varastosta",
		"model-order-from-store": "Malli esillä ja tilattavissa myymälästä",
		"temporarily-out-of-stock": "Tilattavissa myymälästä",
		"not-available": "Ei saatavilla",
		"ask-from-store": "Kysy saatavuus myymälästä"
	}
}
</i18n>
